export default __webpack_public_path__ + "static/media/calendar-active.4cb44ac3.svg";